import Glide from '@glidejs/glide'

if ( $('.js-poker-featured__slider').length )
{
    $('.js-poker-featured__slider').each(function() {
        new Glide(this, {
            type: 'carousel',
            perView: 3,
            gap: 30,
            breakpoints: {
                767: {
                  perView: 2,
                },
                991: {
                    perView: 2,
                  },
              },
              
        }).mount();
    });
}